import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import MemeGenerator from './views/Generator.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/generator',
      name: 'Generator',
      component: MemeGenerator,
      meta: {
        headerClass: 'light',
      },
    },
  ],
})
